import * as Sentry from '@sentry/react';
import { isAxiosError } from 'axios';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import i18n from '~/locales/i18n';
import { isDefined, isError } from '~/types/typeGuards';

type Extra = unknown;
type Extras = Record<string, Extra>;

export const decorateScopeContexts = (scope: Sentry.Scope, error: unknown) => {
  scope.setContext('User Settings', {
    Language: i18n.language,
  });

  if (isDefined(error) && isAxiosError(error)) {
    const { config, response } = error;
    if (isDefined(config)) {
      scope.setExtra('config_url', config.url);
      scope.setExtra('config_method', config.method);
      scope.setExtra('config_headers', config.headers);
    }
    if (isDefined(response)) {
      scope.setExtra('response_status', response.status);
      scope.setExtra('response_headers', response.headers);

      const responseData = response.data;
      if (isDefined(responseData) && isString(responseData)) {
        scope.setExtra('response_data', responseData);
      } else if (isDefined(responseData) && isObject(responseData)) {
        scope.setExtra('response_data', JSON.stringify(responseData));
      } else {
        scope.setExtra('response_data', 'not-parsable-or-not-defined');
      }
    }
  }
};

export const captureException = (error: unknown, { extra }: { extra?: Extras } = {}) => {
  if (isError(error)) {
    Sentry.withScope((scope) => {
      decorateScopeContexts(scope, error);
      if (extra) {
        scope.setExtras(extra);
      }
      Sentry.captureException(error);
    });
  }
  console.error(error);
};

const ExceptionLoggerResult = {
  captureException,
  decorateScopeContexts,
};

const useExceptionLogger = () => ExceptionLoggerResult;

export default useExceptionLogger;
